import { LicenseInfo } from '@mui/x-license';

export const setMUILicenseKey = () => {
  process.env.REACT_APP_MUI_LICENSE_KEY &&
    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);
};
